function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "EEB44755-C6D4-4164-A03E-D0C0A96874FD");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "100%",
  y1: "50%",
  x2: "0%",
  y2: "50%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FAB535",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F7931E",
  offset: "100%"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Design",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "WishMaker-Garancny-fond-1_0_0",
  transform: "translate(-1335.000000, -30.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(1178.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-10",
  transform: "translate(157.000000, 9.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icn_mail",
  transform: "translate(0.000000, 5.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-39",
  stroke: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20,0.5 C20.9664983,0.5 21.8414983,0.891750844 22.4748737,1.52512627 C23.1082492,2.15850169 23.5,3.03350169 23.5,4 L23.5,4 L23.5,16 C23.5,16.9664983 23.1082492,17.8414983 22.4748737,18.4748737 C21.8414983,19.1082492 20.9664983,19.5 20,19.5 L20,19.5 L4,19.5 C3.03350169,19.5 2.15850169,19.1082492 1.52512627,18.4748737 C0.891750844,17.8414983 0.5,16.9664983 0.5,16 L0.5,16 L0.5,4 C0.5,3.03350169 0.891750844,2.15850169 1.52512627,1.52512627 C2.15850169,0.891750844 3.03350169,0.5 4,0.5 L4,0.5 Z",
  id: "Rectangle"
})), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7931E",
  transform: "translate(8.181981, 8.181981) rotate(-315.000000) translate(-8.181981, -8.181981) ",
  x: 1.68198052,
  y: 7.18198052,
  width: 13,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7931E",
  transform: "translate(6.060660, 14.121320) rotate(-45.000000) translate(-6.060660, -14.121320) ",
  x: 2.56066017,
  y: 13.1213203,
  width: 7,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7931E",
  transform: "translate(15.939340, 8.181981) scale(-1, 1) rotate(-315.000000) translate(-15.939340, -8.181981) ",
  x: 9.43933983,
  y: 7.18198052,
  width: 13,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#F7931E",
  transform: "translate(18.060660, 14.121320) scale(-1, -1) rotate(-315.000000) translate(-18.060660, -14.121320) ",
  x: 14.5606602,
  y: 13.1213203,
  width: 7,
  height: 2,
  rx: 1
}))))));

var SvgIcnMail = function SvgIcnMail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "20px",
    viewBox: "0 0 24 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnMail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_mail.ea1048c4.svg";
export { ForwardRef as ReactComponent };